import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DeleteSectionModalState {
    isOpen: boolean;
    confirmed: boolean;
    data: {
        id: number;
        name: string;
        documentId: number;
        chapterId: number;
    } | null;
}

export interface DeleteSectionModalDispatchParams {
    id: number;
    name: string;
    documentId: number;
    chapterId: number;
}

const initialState: DeleteSectionModalState = {
    isOpen: false,
    confirmed: false,
    data: null,
};

export const deleteSectionModalSlice = createSlice({
    name: 'delete-section-modal',
    initialState,
    reducers: {
        open(state, action: PayloadAction<DeleteSectionModalDispatchParams>) {
            return {
                ...state,
                isOpen: true,
                confirmed: false,
                data: action.payload,
            };
        },
        close(state) {
            return {
                ...state,
                isOpen: false,
                data: null,
            };
        },
        confirm(state) {
            return {
                ...state,
                confirmed: true,
            };
        },
    },
});

export default deleteSectionModalSlice.reducer;
